import { useNavigate } from "react-router-dom";

export default function ResetPasswordChanged() {
    const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center bg-[#f4f5f7]">
      <div className="text-center">
        <div className="mb-6 flex justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-16 h-16 text-gray-700"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="1.5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m12 0H4.5m12 0a2.25 2.25 0 012.25 2.25v6.75a2.25 2.25 0 01-2.25 2.25H7.5a2.25 2.25 0 01-2.25-2.25v-6.75a2.25 2.25 0 012.25-2.25m12 0H4.5"
            />
          </svg>
        </div>

        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          Password changed!
        </h1>
        <p className="text-gray-500 mb-6">
          You've Successfully Completed Your Password Reset!
        </p>

        <button
          onClick={() => navigate("/crm/login")}
          className="px-8 py-3 rounded-full bg-[#25300a] text-white font-medium hover:bg-[#0a3021] transition cursor-pointer"
        >
          Log in Now
        </button>
      </div>
    </div>
  );
}
